import React from "react";
import { Toaster } from "react-hot-toast";
import Router from "./router";

function App() {
  
  return (
    <>
      <Router />

      <Toaster
        containerClassName="main-toast-container"
        toastOptions={{
          error: {
            duration: 2000,
          },
        }}
        position="bottom-right"
      />
    </>
  );
}

export default App;
